import React, { useEffect, useState } from "react";
import ViewToggle from "../../../../Components/Utils/ViewToggle";
import {
  CancelButton,
  CreateButton,
  FilterButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import { Link, useLocation } from "react-router-dom";
import SearchBar from "../../../../Components/Utils/SearchBar";
import UseGetData from "../../../../Components/Hooks/useFetchData";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import UseGetDataSearch from "../../../../Components/Hooks/useFetchDataBySearch";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import { useFormik } from "formik";
import * as yup from 'yup';
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import useFetchMetaStar from "../../../../Components/Hooks/useFetchMetaStar";
import Importdoc from "./Importdoc";
import { GetAccess, GetRole, CheckEditAction, CheckDeleteAction } from "../../../../Components/Utils/roles";
import useFetchMDIndex from "../../../../Components/Hooks/useFetchMDIndex";
import useFetchMetaStarIndex from "../../../../Components/Hooks/useFetchMetaStarIndex";
import PremiumTable from "../../../../Components/Others/PremiumTable";
import { useDeleteData } from "../../../../Components/Hooks/useDeleteData";
import ModalContainer from "../../../../Components/Others/ModalContainer";

// Leads Table Row Component
const LeadTableRow = ({
  row,
  pageIndex,
  searchQuery,
  canEdit,
  canDelete,
  handleDelete,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handle = async () => handleDelete("/leads/" + `${row.leadId}`, setIsModalOpen);
  return (
    <>
      <tr className="bg-white hover:bg-white/80 transition-colors align-middle">
        {/* ID */}
        <td className="p-4 text-center align-middle border-t border-b border-l border-gray-200/60 rounded-tl-xl rounded-bl-xl text-xs font-semibold text-gray-500">
          {row.leadId}
        </td>

        {/* Name */}
        <td className="p-4 align-middle border-t border-b border-gray-200/60 font-semibold text-sm text-gray-800">
          <Link
            to={`/marketing/leads/view/${row.leadId}`}
            state={{ data: row, pageIndex, searchQuery }}
            className="hover:underline text-sm font-bold text-gray-800"
          >
            {row.name || "N/A"}
          </Link>
        </td>

        {/* Lead Source */}
        <td className="p-4 align-middle border-t border-b border-gray-200/60 whitespace-nowrap text-xs font-semibold text-gray-600">
          {row.leadSource || "N/A"}
        </td>

        {/* Industry */}
        <td className="p-4 align-middle border-t border-b border-gray-200/60 whitespace-nowrap">
          <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold bg-emerald-50 text-emerald-700 border border-emerald-100">
            {row.industry || "N/A"}
          </span>
        </td>

        {/* Action Buttons */}
        <td className="p-4 text-center align-middle border-t border-b border-r border-gray-200/60 rounded-tr-xl rounded-br-xl">
          <div className="flex items-center justify-center gap-1.5">
            {/* View */}
            <Link
              to={`/marketing/leads/view/${row.leadId}`}
              state={{ data: row, pageIndex, searchQuery }}
              className="border border-blue-200 text-blue-600 hover:bg-blue-50 p-1.5 rounded-md transition-all duration-200 flex items-center justify-center"
              title="View details"
            >
              <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
            </Link>
            {/* Edit */}
            {CheckEditAction(row, "Leads", canEdit) && (
              <Link
                to={`/marketing/leads/edit/${row.leadId}`}
                state={{ data: row, from: "/marketing/leads", pageIndex, searchQuery }}
                className="border border-sky-200 text-[#0ea5e9] hover:bg-sky-50 p-1.5 rounded-md transition-all duration-200 flex items-center justify-center"
                title="Edit lead"
              >
                <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-5M18.5 2.5a2.121 2.121 0 113 3L12 15l-4 1 1-4 9.5-9.5z" />
                </svg>
              </Link>
            )}
            {/* Delete */}
            {CheckDeleteAction(row, canDelete) && (
              <button
                onClick={() => setIsModalOpen(true)}
                className="border border-red-200 text-red-500 hover:bg-red-50 p-1.5 rounded-md transition-all duration-200 flex items-center justify-center"
                title="Delete lead"
              >
                <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
              </button>
            )}
          </div>
        </td>
      </tr>
      <ModalContainer
        visiable={isModalOpen}
        title="Warning"
        content={`Are you sure, ${row.name} will be removed from Leads!`}
        handleClick={() => handle()}
        closeModal={() => setIsModalOpen(false)}
      />
    </>
  );
};

// Leads Card Component
const LeadCard = ({
  row,
  pageIndex,
  searchQuery,
  canEdit,
  canDelete,
  handleDelete,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handle = async () => handleDelete("/leads/" + `${row.leadId}`, setIsModalOpen);
  return (
    <div className="relative border border-y-gray-200/50 border-r-gray-200/50 shadow-[0_4px_20px_rgba(0,0,0,0.05)] hover:shadow-[0_10px_30px_rgba(0,0,0,0.08)] transition-all duration-300 rounded-2xl bg-white p-4 sm:p-5 flex flex-col gap-3.5 overflow-hidden border-l-4 border-l-emerald-500">
      {/* Card Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start gap-3">
        <div className="flex flex-col min-w-0 flex-1">
          <Link
            to={`/marketing/leads/view/${row.leadId}`}
            state={{ data: row, pageIndex, searchQuery }}
            className="text-gray-800 font-bold hover:underline text-sm truncate"
          >
            {row.name || "N/A"}
          </Link>
          <span className="text-[10px] text-gray-400 font-bold mt-0.5">ID: #{row.leadId}</span>
        </div>

        {/* Industry Tag */}
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold bg-emerald-50 text-emerald-700 border border-emerald-100 shrink-0">
          {row.industry || "N/A"}
        </span>
      </div>

      {/* Contact Details */}
      <div className="flex flex-col gap-1 px-1 text-xs text-gray-600 font-medium">
        {row.email && (
          <div className="flex justify-between items-center gap-2">
            <span>Email:</span>
            <span className="font-semibold text-gray-800 truncate ml-2">{row.email}</span>
          </div>
        )}
        {row.mobile?.display && (
          <div className="flex justify-between items-center gap-2">
            <span>Phone:</span>
            <span className="font-semibold text-gray-800 truncate ml-2">{row.mobile.display}</span>
          </div>
        )}
      </div>

      {/* Middle Grid */}
      <div className="bg-[#FAFAFC]/80 rounded-xl p-3 border border-gray-100 flex flex-wrap sm:flex-nowrap justify-between items-center gap-2 text-xs">
        <div className="flex flex-col gap-0.5 flex-1 min-w-[90px]">
          <span className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider">Source</span>
          <span className="font-bold text-gray-700 truncate">{row.leadSource || "--"}</span>
        </div>
        <div className="hidden sm:block w-[1px] h-7 bg-gray-200/60" />
        <div className="flex flex-col gap-0.5 flex-1 min-w-[90px] pl-0 sm:pl-2">
          <span className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider">Ratings</span>
          <span className="font-bold text-gray-700 truncate">{row.ratings || "--"}</span>
        </div>
      </div>

      {/* Action Buttons Row */}
      <div className="flex flex-wrap sm:flex-nowrap items-center justify-between gap-2 border-t border-gray-100 pt-3 mt-0.5">
        <Link
          to={`/marketing/leads/view/${row.leadId}`}
          state={{ data: row, pageIndex, searchQuery }}
          className="border border-gray-200 text-gray-600 hover:bg-gray-50 px-3 py-1.5 rounded-lg transition-all duration-200 flex items-center justify-center gap-1.5 text-xs font-semibold flex-1 sm:flex-none"
        >
          <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
          </svg>
          View Details
        </Link>
        <div className="flex gap-2 flex-1 sm:flex-none justify-end">
          {CheckEditAction(row, "Leads", canEdit) && (
            <Link
              to={`/marketing/leads/edit/${row.leadId}`}
              state={{ data: row, from: "/marketing/leads", pageIndex, searchQuery }}
              className="border border-gray-200 text-gray-600 hover:bg-gray-50 px-3 py-1.5 rounded-lg transition-all duration-200 flex items-center justify-center gap-1.5 text-xs font-semibold flex-1 sm:flex-none"
            >
              <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-5M18.5 2.5a2.121 2.121 0 113 3L12 15l-4 1 1-4 9.5-9.5z" />
              </svg>
              Edit
            </Link>
          )}
          {CheckDeleteAction(row, canDelete) && (
            <button
              onClick={() => setIsModalOpen(true)}
              className="border border-red-100 text-red-500 hover:bg-red-50 px-3 py-1.5 rounded-lg transition-all duration-200 flex items-center justify-center gap-1.5 text-xs font-semibold flex-1 sm:flex-none cursor-pointer"
            >
              <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
              Delete
            </button>
          )}
        </div>
      </div>
      <ModalContainer
        visiable={isModalOpen}
        title="Warning"
        content={`Are you sure, ${row.name} will be removed from Leads!`}
        handleClick={() => handle()}
        closeModal={() => setIsModalOpen(false)}
      />
    </div>
  );
};

function LeadsIndex() {
  const location = useLocation();
  const currentPage = location.state?.currentPage;
  const searchQuery = location.state?.searchQuery;
  const [page, setPage] = useState(currentPage || 1);
  const [pageCount, setPageCount] = useState(localStorage.getItem("perPageView") || 20);

  const [filter, setFilter] = useState(false);
  const [showFilterDialog, setShowFilterDialog] = useState(false);
  const [viewMode, setViewMode] = useState(localStorage.getItem("leadsViewMode") || "table");
  const [isMobileScreen, setIsMobileScreen] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileScreen(window.innerWidth < 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const effectiveViewMode = isMobileScreen ? "card" : viewMode;

  const { value: Industry } = useFetchMDIndex(`/dropdown/dropdown-details/`, 'Industry_leads', showFilterDialog);
  const { value: LeadStatus } = useFetchMDIndex(`/dropdown/dropdown-details/`, 'lead_Status', showFilterDialog);
  const { value: LeadsRatings } = useFetchMetaStarIndex(`/dropdown/dropdown-details/`, 'leadsRating', showFilterDialog);

  const [filterProps, setFilterProps] = useState({
    ratings: "",
    industry: "",
    status: ""
  });
  const [params, setParams] = useState({
    page: page,
    per_page: pageCount,
    search: searchQuery || "",
    ratings: "",
    industry: "",
    status: ""
  });

  const clearFilter = () => {
    setParams({
      ...params,
      ratings: "",
      industry: "",
      status: ""
    });
    formik.values.status = "";
    formik.values.industry = "";
    formik.values.ratings = "";

    setFilter(false);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: filterProps,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({}),
    onSubmit: async (value, { resetForm }) => {
      setParams({ ...params, status: value.status, industry: value.industry, ratings: value.ratings, page: 1 });
      setPage(1);
      closeFilterDialog();
      setFilter(true);
    }
  });

  const { data, totalCount, getData, dataLoading } = UseGetDataSearch("/leads/", params);

  useEffect(() => {
    setParams({ ...params, page: page, per_page: pageCount });
  }, [page, pageCount]);

  const closeFilterDialog = () => {
    setShowFilterDialog(false);
  };
  const [showImportModal, setShowImportModal] = useState(false);

  const handleImportClick = () => {
    setShowImportModal(true);
  };

  const closeModal = () => {
    setShowImportModal(false);
  };
  const canEdit = GetAccess("leads_edit") || GetRole();
  const canDelete = GetAccess("leads_delete") || GetRole();
  const { handle: handleDelete } = useDeleteData(getData);

  return (
    <div className="w-full h-full px-2 sm:px-4 py-2">
      <div className="w-full flex flex-col md:flex-row justify-between items-stretch md:items-center gap-2 md:gap-3 mb-3">
        <div className="w-full md:w-auto flex justify-between items-center gap-2">
          <Breadcrumb
            items={[
              {
                name: "Lead",
              },
            ]}
          />
          <div className="flex md:hidden items-center gap-2">
            <FilterButton handleClick={() => setShowFilterDialog(true)} />
            {filter && <FilterButton handleClick={() => clearFilter()} label="Clear" />}
            {GetAccess("leads_create") && (
              <Link to="/marketing/leads/create/">
                <CreateButton label="Lead" />
              </Link>
            )}
          </div>
        </div>

        <div className="w-full md:w-auto flex flex-wrap md:flex-nowrap items-center gap-2">
          <div className="w-full md:w-fit">
            <SearchBar
              handleChange={(e) => {
                setParams({ ...params, search: e.target.value, page: 1 });
                setPage(1);
              }}
              value={params.search || searchQuery}
            />
          </div>
          <div className="hidden md:flex items-center gap-2">
            <FilterButton handleClick={() => setShowFilterDialog(true)} />
            {filter && <FilterButton handleClick={() => clearFilter()} label="Clear" />}
          </div>

          {/* Table / Card View Toggle */}
          <ViewToggle
            viewMode={effectiveViewMode}
            onViewChange={(mode) => setViewMode(mode)}
            storageKey="leadsViewMode"
          />

          <div className="hidden md:flex items-center gap-2">
            {GetAccess("leads_create") && (
              <Link to="/marketing/leads/create/">
                <CreateButton label="Lead" />
              </Link>
            )}
          </div>
        </div>
      </div>

      <PremiumTable
        data={data}
        total={totalCount}
        pageIndex={page}
        setPageIndex={setPage}
        dataCount={pageCount}
        setDataCount={setPageCount}
        viewMode={effectiveViewMode}
        headers={[
          { title: "ID", width: "70px" },
          { title: "Name", width: "auto" },
          { title: "Lead Source", width: "150px" },
          { title: "Industry", width: "140px" },
          { title: "Action", align: "center", width: "100px" }
        ]}
        renderRow={(row, idx) => (
          <LeadTableRow
            row={row}
            pageIndex={page}
            searchQuery={params?.search || ""}
            canEdit={canEdit}
            canDelete={canDelete}
            handleDelete={handleDelete}
          />
        )}
        renderCard={(row, idx) => (
          <LeadCard
            row={row}
            pageIndex={page}
            searchQuery={params?.search || ""}
            canEdit={canEdit}
            canDelete={canDelete}
            handleDelete={handleDelete}
          />
        )}
        dataLoading={dataLoading}
      />

      {showFilterDialog && (
        <div className="fixed inset-0 bg-gray-900/60 backdrop-blur-xs z-[9999] flex justify-center items-center p-3 sm:p-4">
          <div className="animate-scale-in w-[92vw] sm:w-[480px] max-w-full max-h-[85vh] bg-white p-5 sm:p-6 rounded-2xl shadow-2xl overflow-y-auto flex flex-col">
            <div className="flex justify-between items-center pb-3 border-b border-gray-100 mb-4">
              <h2 className="text-lg font-bold text-gray-800">Filter Lead</h2>
              <button
                onClick={closeFilterDialog}
                type="button"
                className="text-gray-400 hover:text-gray-600 p-1 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <form onSubmit={formik.handleSubmit} className="flex flex-col gap-2">
              <div className="flex flex-col gap-1">
                <FormikSelectTwo
                  type="text"
                  label="Industry"
                  placeholder="Choose"
                  Options={Industry}
                  formik={formik}
                  name="industry"
                  width="w-full"
                  px="0"
                />
                <FormikSelectTwo
                  type="text"
                  label="Status"
                  placeholder="Choose"
                  Options={LeadStatus}
                  formik={formik}
                  name="status"
                  width="w-full"
                  px="0"
                />
              </div>

              <div className="flex justify-end gap-2.5 pt-4 mt-2 border-t border-gray-100">
                <CancelButton handleClick={closeFilterDialog} />
                <SubmitButton name="Apply" />
              </div>
            </form>
          </div>
        </div>
      )}
      {showImportModal && <Importdoc show={showImportModal} onClose={closeModal} getData={getData} />}
    </div>
  );
}
export default LeadsIndex;
